"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import Image from "./webflow_modules/Basic/components/Image";
import Link from "./webflow_modules/Basic/components/Link";

export function ExploreCard({
  altText = "",
  image = "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/656be1165608e1e4ed4e001a_Rectangle-83.png",

  link = {
    href: "#",
  },

  text = "Apartment Homes",
}) {
  return (
    <Link
      block={"inline"}
      button={false}
      className={"explore_card"}
      options={link}
    >
      <Block className={"explore_card-image-wrapper"} tag={"div"}>
        <Image
          className={"explore_card-image"}
          height={"Auto"}
          loading={"lazy"}
          src={image}
          width={"Auto"}
        />
      </Block>
      <Block className={"text-size-large text-color-blue"} tag={"div"}>
        {text}
      </Block>
    </Link>
  );
}
